/* eslint-disable react-hooks/rules-of-hooks */
import style from "./index.module.scss"
import { useState, useEffect } from "react";
import { DialogTitle, DialogContent } from "@mui/material"
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import UKDialog from "@/components/UKDialog";
import { EXPOSURE_RECORD } from "@/tracks/25158"
import { EXPCONFIG_FAST } from "@/constants/point";
import { useTranslation } from "@/i18n/client";

type Props = {
  open: boolean;
  content: string;
  closeFn: () => void;
};

const DialogStyle = {
  "& .MuiDialog-paper": {
      width: "660px",
      maxHeight: "660px",
      margin: "0",
  },
  '& .MuiDialogTitle-root': {
    fontSize: "16px",
    fontWeight: "bold",
    lineHeight: "20px",
    padding: "20px 24px 20px 24px",
  },
}

const ContentStyle = {
  display: "flex",
  flexDirection: "column",
  padding: "24px",
  paddingTop: "0",
}

export default function TermsDialog({ open, content, closeFn } : Props){

  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const closeHandler = () => {
    setIsOpen(false);
    closeFn && closeFn();
  }

  useEffect(() => {
    setIsOpen(open);
  }, [open])

  return(
    <UKDialog open={isOpen} onClose={closeHandler} showCloseBtn={false} sx={DialogStyle}
    >
      <DialogTitle>{t("profile.inviteFriend.termTitle")}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={closeHandler}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={ContentStyle}>
        <div 
          className={style.termsdialog_content}
          dangerouslySetInnerHTML={{__html: `<pre>${content}</pre>`}}
          exptag={"exp|" + EXPOSURE_RECORD.Activity_Yqyl_Rules_Expo}
          data-exptag-config={EXPCONFIG_FAST}
        />
      </DialogContent>
    </UKDialog>
  )
}
